interface LineBreakOptions {
    maxLines?: number;
    ellipsis?: string;
    lineLength?: number;
}

const SIDE_SEP_LENGTH = 5;
const DEFAULT_MAX_LINES = 2;
const DEFAULT_ELLIPSIS = '...';

const isEnglishWord = (text: string): boolean => {
    return /^[a-zA-Z_]+$/.test(text);
};

const insertLineBreaker = (text: string, options: LineBreakOptions = {}): string => {
    if (!text) return '';

    const { lineLength = SIDE_SEP_LENGTH, maxLines = DEFAULT_MAX_LINES, ellipsis = DEFAULT_ELLIPSIS } = options;

    if (text.length <= lineLength) {
        return text;
    }

    // 分割文本，但保留分隔符
    // 使用正则的捕获组来保留分隔符
    const tokens = text.split(/([\s]+)/);
    const lines: string[] = [];
    let currentLine = '';

    for (const token of tokens) {
        // 处理英文单词
        if (isEnglishWord(token) && token.length > lineLength) {
            if (currentLine) {
                lines.push(currentLine);
                currentLine = '';
            }

            if (lines.length >= maxLines - 1) {
                const lastLine = token.slice(0, lineLength - ellipsis.length) + ellipsis;
                lines.push(lastLine);
                return lines.join('\n');
            }

            lines.push(token);
            continue;
        }

        // 处理需要分割的长文本
        if (token.length > lineLength) {
            if (currentLine) {
                lines.push(currentLine);
                currentLine = '';
            }

            for (let i = 0; i < token.length; i += lineLength) {
                if (lines.length >= maxLines - 1) {
                    const lastPart = token.slice(i, i + lineLength - ellipsis.length) + ellipsis;
                    lines.push(lastPart);
                    return lines.join('\n');
                }
                const part = token.slice(i, i + lineLength);
                lines.push(part);
            }
            continue;
        }

        // 处理正常长度的token
        const potentialLine = currentLine ? currentLine + token : token;
        if (potentialLine.length <= lineLength) {
            currentLine = potentialLine;
        } else {
            if (lines.length >= maxLines - 1) {
                const lastLine = currentLine.slice(0, lineLength - ellipsis.length) + ellipsis;
                lines.push(lastLine);
                return lines.join('\n');
            }

            lines.push(currentLine);
            currentLine = token;
        }
    }

    // 处理最后一行
    if (currentLine) {
        if (lines.length < maxLines) {
            lines.push(currentLine);
        } else {
            const lastLine = currentLine.slice(0, lineLength - ellipsis.length) + ellipsis;
            lines[lines.length - 1] = lastLine;
        }
    }

    return lines.join('\n');
};

const onFormatterLabel = (val: string, lineLength = SIDE_SEP_LENGTH) => {
    return insertLineBreaker(val, { lineLength });
};

export { SIDE_SEP_LENGTH, onFormatterLabel };
